import React from 'react'

import EmailAcknowledgeLayout from './emailAcknowledge/Layout'

const EmailAcknowledgeView = () => {
  return <EmailAcknowledgeLayout />
}

export default EmailAcknowledgeView
